import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import classes from "./SortableItem.module.scss";

export function SortableItem(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "none",
    scale: isDragging ? 1.05 : 1, // ドラッグ中は少し大きくする
    opacity: isDragging ? 0.5 : 1, // ドラッグ中は少し透明にする
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={isDragging ? classes.contentBodyDragging : classes.contentBody}
    >
      {props.children}
    </div>
  );
}
